import React from "react";
import { Link,withRouter } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useGlobalContext } from "../../context/cart_context";
import "./Navbar.css";
import logo from '../../asset/images/logo.png'
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { propsToClassKey } from "@mui/styles";
function Navbar(props) {
  const { isAuthenticated, user, loginWithRedirect, logout } = useAuth0();
  const isUser = isAuthenticated && user;
  const { amount } = useGlobalContext();
  return (
    <div className="nav">
      <div className="nav-container">
        <div className="logo">
            <img src={logo}/>
            {/* <span className="txtWelcome">Zoi fintech services</span> */}
        </div>

        {/* <ul className="links">
          <Link to="/">
            <li>Home</li>
          </Link>
          <Link to="/products">
            <li>Products</li>
          </Link>
        </ul> */}

        <div className="user">
        <Link to="/">
            <i className="fa fa-home fa-lg cart-icon"></i>{" "}
          </Link>
          {/* {isUser ? (
            <button
              className="login"
              onClick={() => logout({ returnTo: window.location.origin })}
            >
              Log out
            </button>
          ) : (
            <button className="login" onClick={loginWithRedirect}>
              Log in
            </button>
          )} */}
          
          <Link to="/cart">
            <i className="fa fa-shopping-cart fa-lg cart-icon"></i>{" "}
          </Link>
          <div className="nav-item">
            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M16 6v2h2l2 12H0L2 8h2V6a6 6 0 1 1 12 0zm-2 0a4 4 0 1 0-8 0v2h8V6zM4 10v2h2v-2H4zm10 0v2h2v-2h-2z" />
            </svg> */}
            <div className="amount-container">
              <p className="total-amount">{props.count!=undefined&&props.count!=null?props.count.length:0}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  count:state.AddToCart.addToCart
  // entryFormList: state.EntryFormList.entryFormList,
  // bankList:
  //   state.BankList.bankList.data != null &&
  //     state.BankList.bankList.data.length != 0
  //     ? state.BankList.bankList.data
  //     : [],
  // loader: state.EntryFormList.isLoading,
  // loginDetails:state.Login.loginDetails.Table1!=null&&state.Login.loginDetails.Table1.length!=0?state.Login.loginDetails.Table1:[],
});
export default withRouter(
  connect(mapStateToProps, null)(Navbar)
);
